  var __pdpStrapWrapper = document.querySelector(".custom_variant_options_wpr");

  function relocateStrapPickerBetweenFlavorAndSize() {
    try {
      var wrapper = __pdpStrapWrapper;
      var variantFieldsets = document.querySelectorAll("variant-selects fieldset");
      if (!wrapper || variantFieldsets.length < 2) return false;
      var flavorFieldset = variantFieldsets[0];
      var sizeFieldset = Array.prototype.find.call(variantFieldsets, function (fs) {
        var legend = fs.querySelector("legend");
        return legend && /size/i.test(legend.textContent);
      });
      if (!sizeFieldset || !sizeFieldset.parentElement) return false;

      // The theme previously made this block "float" over a fixed-size gap
      // between the Flavor and Size fieldsets using position:absolute + a
      // negative margin, tuned for the old dropdown+carousel's height. That
      // silently breaks (overlap) whenever this block's real height changes
      // — e.g. a strap category with 2 rows of designs instead of 1. Moving
      // it into normal document flow, physically between the two fieldsets,
      // means it always pushes "Choose Your Size" down by exactly however
      // tall its content actually is, at any width, any zoom, any category.
      wrapper.style.position = "static";
      wrapper.style.top = "auto";
      wrapper.style.marginTop = "0";

      // The Flavor fieldset carried a large fixed margin-bottom (that old
      // reserved gap for the float). Now that this block occupies the space
      // for real, that reserved gap is just empty space — collapse it to a
      // normal gap instead.
      if (flavorFieldset && flavorFieldset !== sizeFieldset) {
        flavorFieldset.style.marginBottom = "24px";
      }

      sizeFieldset.parentElement.insertBefore(wrapper, sizeFieldset);

      var summaryEl = document.getElementById("strap-selection-category");
      if (summaryEl && summaryEl.parentElement) {
        summaryEl.parentElement.style.marginBottom = "20px";
      }
      return true;
    } catch (e) {
      console.error("Error relocating strap picker:", e);
      return false;
    }
  }

  relocateStrapPickerBetweenFlavorAndSize();

  // Shopify's native <variant-selects> element completely replaces its own
  // DOM subtree every time a variant option changes (see product-info.js:
  // updateOptionValues -> HTMLUpdateUtility.viewTransition). It fetches a
  // freshly server-rendered copy of <variant-selects> and swaps it in
  // wholesale, then removes the old one ~500ms later. Since this strap
  // picker block only ends up *inside* <variant-selects> because of the
  // runtime relocation above (it isn't part of the server-rendered markup
  // there), every variant change was silently destroying it along with the
  // old <variant-selects> node. Watch for that swap and re-run the exact
  // same relocation on the freshly inserted <variant-selects> each time —
  // reusing the SAME wrapper element (not a clone), so any in-progress
  // category/design selection is preserved across a flavor change instead
  // of resetting.
  try {
    var pdpStrapObserveTarget = document.querySelector(".product__info-container") || document.body;
    var pdpStrapObserver = new MutationObserver(function () {
      var activeVariantSelects = document.querySelector("variant-selects");
      if (!activeVariantSelects) return;
      if (!activeVariantSelects.contains(__pdpStrapWrapper)) {
        relocateStrapPickerBetweenFlavorAndSize();
      }
    });
    pdpStrapObserver.observe(pdpStrapObserveTarget, { childList: true, subtree: true });
  } catch (e) {
    console.error("Error setting up strap picker relocation observer:", e);
  }


  const strap_select = document.getElementById("strap-design-select");
  const imageGroups = document.querySelectorAll(".strap-images");
  const strp_cat = document.getElementById("strp_cat");
  const strp_dsgn = document.getElementById("strp_dsgn");
  const strp_dsgn_image = document.getElementById("strp_dsgn_image");
  const categoryTabs = document.querySelectorAll(".strap-category-tab");
  const summaryCategoryEl = document.getElementById("strap-selection-category");

  // Persistent variable for the selected variant
  let selectedVariantWithStrapValue = '';

  // Event listener to capture result from strap selection event
  window.addEventListener('strap-result-ready', (e) => {
    selectedVariantWithStrapValue = e.detail.result;
  });

  function updateFromSelectedImage() {

    const selectedImg = document.querySelector('.strap-images .splide__slide img.selected');
    if (!selectedImg) return;

    const currentValue = selectedImg.alt;

    let parts = selectedVariantWithStrapValue.split(' / ');
    parts[parts.length - 1] = currentValue;
    selectedVariantWithStrapValue = parts.join(' / ');

    getAndSetSlider(selectedVariantWithStrapValue)

  }


  initSplideCarousels()


  function setActiveTab(selectedValue) {
    categoryTabs.forEach(tab => {
      const isActive = tab.getAttribute("data-category") === selectedValue;
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      if (isActive) {
        tab.style.background = "#007F99";
        tab.style.color = "#fff";
        tab.style.border = "1px solid #007F99";
      } else {
        tab.style.background = "#fff";
        tab.style.color = "#0B4A55";
        tab.style.border = "1px solid #cfe3e1";
      }
    });
    if (summaryCategoryEl) summaryCategoryEl.textContent = selectedValue;
  }


  function updateImages() {
    const selectedValue = strap_select.value;

    imageGroups.forEach(group => {
      const groupValue = group.getAttribute("data-option");
      if (!groupValue) return;

      if (groupValue === selectedValue) {
        group.style.display = "block";

        const firstImg = group.querySelector("img");
        if (firstImg) {
          selectImage(firstImg);
        }
      } else {
        group.style.display = "none";
      }
    });

    if (strp_cat) strp_cat.value = selectedValue;
    setActiveTab(selectedValue);
  }



  // Ensure default dropdown value on page load
  if (!strap_select.value && strap_select.options.length > 0) {
    strap_select.value = strap_select.options[0].value;
  }

  function selectImage(imgElement) {
    if (!imgElement) return;

    document.querySelectorAll(".strap-images .splide__slide").forEach(wrapper => {
      wrapper.style.border = "1px solid #e3e8e7";
      const img = wrapper.querySelector("img");
      if (img) img.classList.remove("selected");
    });

    imgElement.classList.add("selected");
    if (imgElement.parentElement) {
      imgElement.parentElement.style.border = "2px solid #D36043";
    }

    if (strp_dsgn) strp_dsgn.value = imgElement.alt;
    if(strp_dsgn_image) strp_dsgn_image.value = imgElement.src;

  }


  document.addEventListener("click", function (e) {
    if (e.target.matches(".strap-images img")) {
      selectImage(e.target);
    }
  });


  strap_select.addEventListener("change", updateImages);

  categoryTabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const category = tab.getAttribute("data-category");
      if (!category || category === strap_select.value) return;
      strap_select.value = category;
      // NOTE: bubbles is intentionally false here (was previously `true`).
      // The only listener this event needs to reach is the direct one
      // registered on this same <select> below (`strap_select.addEventListener
      // ("change", updateImages)`), so bubbling was never required. Letting it
      // bubble caused it to reach Shopify's native <variant-selects> change
      // handler (VariantSelects.onVariantChange -> updateSelectionMetadata in
      // global.js), which expects a real product-option change and threw
      // "Cannot read properties of undefined (reading 'removeAttribute')"
      // on every single topping-category click.
      strap_select.dispatchEvent(new Event("change", { bubbles: false }));
    });
  });


  updateImages();
  updateFromSelectedImage()
